import { render, staticRenderFns } from "./WorkBookMathQuestionList.vue?vue&type=template&id=06dca736&scoped=true&"
import script from "./WorkBookMathQuestionList.vue?vue&type=script&lang=js&"
export * from "./WorkBookMathQuestionList.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookMathQuestionList.vue?vue&type=style&index=0&id=06dca736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dca736",
  null
  
)

export default component.exports